import React, { useEffect, useState } from 'react';
import { CheckboxOptionType } from 'antd/lib/checkbox';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import Accordion from 'src/components/common/Accordion';
import RadioGroupList from 'src/components/common/RadioGroupList';
import useQueryUrlParamsDispatch from 'src/hooks/useQueryUrlParamsDispatch';
import useQueryUrlParams from 'src/hooks/useQueryUrlParams';
import styles from './PriceTypeFilter.module.less';

const DEFAULT_OPTIONS = [
  { label: 'Regular Price', value: '1' },
  { label: 'Lowest Price', value: '2' },
];

const defaultPriceType = DEFAULT_OPTIONS[1].value;

type PriceTypeFilterProps = {
  defaultOptions?: CheckboxOptionType[];
  header?: string;
};

const PriceTypeFilter: React.FC<PriceTypeFilterProps> = ({
  defaultOptions = DEFAULT_OPTIONS,
  header = 'Price Type',
}) => {
  const setQuery = useQueryUrlParamsDispatch();
  const { priceType } = useQueryUrlParams();
  const [selectedItems, setSelectedItems] = useState<CheckboxValueType>(priceType ?? defaultPriceType);

  useEffect(() => {
    setSelectedItems(priceType ?? defaultPriceType);
  }, [priceType]);

  const handleChange = (value: string): void => {
    setQuery({ priceType: value !== defaultPriceType ? value : null });
    setSelectedItems(value);
  };

  return (
    <Accordion header={header}>
      <div className={styles.wrapper}>
        <RadioGroupList onChange={handleChange} options={defaultOptions} value={selectedItems} />
      </div>
    </Accordion>
  );
};
export default PriceTypeFilter;
